// InvoiceBrandingDTO upsert request and read response share this shape.
// hasLogo is server-computed (response only) and ignored on upsert.
export interface InvoiceBranding {
  institutionId: string;
  displayName?: string;
  address?: string;
  phone?: string;
  email?: string;
  website?: string;
  tin?: string;
  vatRegNo?: string;
  areaCode?: string;
  bankAccountName?: string;
  bankAccountNumber?: string;
  bankName?: string;
  bankBranch?: string;
  bankRoutingNo?: string;
  bankSwift?: string;
  paymentInstructions?: string;
  footerNote?: string;
  signatureLeftLabel?: string;
  signatureRightLabel?: string;
  showSignatures: boolean;
  showAmountInWords: boolean;
  hasLogo?: boolean;
  // ---- F7 invoice layout (null/undefined on upsert keeps the stored value) ----
  layout?: InvoiceLayout;
  showDiscountColumn?: boolean;
  showTaxRateColumn?: boolean;
  showHsCodeColumn?: boolean;
  termsText?: string;
  banglaLabels?: boolean;
  hasSignatureImage?: boolean; // response only
}

export type InvoiceLayout = 'CLASSIC' | 'COMPACT' | 'BANK_BLOCK';

export const INVOICE_LAYOUTS: { id: InvoiceLayout; label: string; hint: string }[] = [
  { id: 'CLASSIC', label: 'Classic', hint: 'The standard invoice' },
  { id: 'COMPACT', label: 'Compact', hint: 'Smaller margins and a one-line header, for invoices with many lines' },
  { id: 'BANK_BLOCK', label: 'Bank block', hint: 'Classic with a boxed bank and payment block before the totals' },
];
